import { Component, OnInit, signal } from '@angular/core';
import { FeatureFlagsService } from 'src/app/services/infra/featureFlags/feature-flags.service';
import { FeatureFlagTypes } from 'src/app/models/featureFlag/featureFlagsTypes.enum';

@Component({
  selector: 'app-ai-prevention-page',
  templateUrl: './ai-prevention-page.component.html',
  styleUrls: ['./ai-prevention-page.component.scss'],
})
export class AiPreventionPageComponent implements OnInit {
  public isLoading = signal<boolean>(false);
  public preventionTooltipLabelPath = 'enterpriseAiDetectionPage.tabs.preventionTooltip';
  public isAccountAuthorizedToViewMockPrevention = false;

  constructor(private readonly _featureFlagsService: FeatureFlagsService) {}

  ngOnInit(): void {
    this.isAccountAuthorizedToViewMockPrevention = this._featureFlagsService.isFeatureEnabled(
      FeatureFlagTypes.AIRuntimePreventionMockTab
    );
  }
}
